import '../../css/common.css'
import './home.css'
import HomeContent from './HomeContent';
import ContactBanner from '../ContactBanner';
import ProjectSection from '../Projects/ProjectSection';
import HomeTeamSection from './HomeTeamSection';
import Pitches from '../Projects/Pitches';
import ContactFooter from '../ContactFooter';
import useScrollTo from '../../hooks/useScrollTo';

const Home = () => {
  useScrollTo();

  return (
    <>
      <HomeContent />
      <ContactBanner />
      <ProjectSection />
      <HomeTeamSection />
      <Pitches />
      <ContactFooter />
    </>
  );
}

export default Home;
